<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Recibo #{{ payment.id }}</span>
      </h1>
      <div>
        <PrimaryButton @click="printPage" class="px-5">Imprimir</PrimaryButton>
      </div>
    </div>
  </div>

  <div v-if="!loading" class="align p-4 space_title">

    <div class="card">
      <div class="p-4 pb-3">

        <div class="d-flex">
          <img src="@/assets/images/logo.png" width="190" height="48" class="mt-3" />

          <p class="ms-auto mt-2">
            1News Brasil LTDA - EPP<br />
            CNPJ: 25.332.831/0001/91<br />
            contato@i7.network
          </p>
        </div>

      </div>

      <div class="divisor"></div>

      <div class="p-4">

        <h6 class="mb-5"><i class="fa-light fa-user me-2"></i> Recebedor</h6>

        <div class="row">
          <div class="col">
            <strong>Nome</strong>
            <p v-if="payment.user" class="mb-0">{{ payment.user.name }}</p>
          </div>
          <div class="col">
            <strong>Documento</strong>
            <p v-if="payment.user" class="mb-0">{{ payment.user.document }}</p>
          </div>
          <div class="col">
            <strong>E-mail</strong>
            <p v-if="payment.user" class="mb-0">{{ payment.user.email }}</p>
          </div>
        </div>
    </div>

    <div class="divisor"></div>

      <div class="p-4">
        <h6 class="mb-5"><i class="fa-light fa-building-columns me-2"></i> Dados bancários</h6>

        <div class="row">
          <div class="col">
            <strong>Banco</strong>
            <p class="mb-0">{{ payment.bank.name }}</p>
          </div>
          <div class="col">
            <strong>Agência</strong>
            <p class="mb-0">{{ payment.bank.agency }}<span v-if="payment.bank.agency_digit">-{{ payment.bank.agency_digit }}</span></p>
          </div>
          <div class="col">
            <strong>Conta</strong>
            <p class="mb-0">{{ payment.bank.account }}<span v-if="payment.bank.account_digit">-{{ payment.bank.account_digit }}</span></p>
          </div>
        </div>
  </div>

      <table class="mt-2 mb-2">
        <thead>
          <tr>
            <th class="px-4">Descrição</th>
            <th class="px-4">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="px-4">Colaboração editorial</td>
            <td class="px-4">{{ $moneyFormat(payment.amount) }}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>
  
<script setup>
import RedirectBack from '@/components/RedirectBack.vue'
import { inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { usePaymentStore } from '@/stores/PaymentStore';
import PrimaryButton from '@/components/PrimaryButton.vue';

const loader = inject('$loader');
const loading = ref(false);

const paymentStore = usePaymentStore();
const { payment } = storeToRefs(paymentStore);

const route = useRoute();

onMounted(async () => {
  paymentStore.payment = {};


  const id = route.params.id;
  if(id){
    loader.show();
    loading.value = true;

    await paymentStore.getPayment(id);

    loader.hide();
    loading.value = false;
  }
});

const printPage = () => {
  window.print();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}

table {
  border-top: 1px #d7d7d7 solid;
}

.dark table {
    border-color: #414556;
}
</style>

<style>
@media print {
  body {
    background-color: #fff !important;
    height: auto !important;
  }

  nav {
    display: none;
  }

  #content {
    padding-left: 0 !important;
  }

  .page_title {
    padding-left: 0 !important;
    border-bottom: 0 !important;
  }

  .page_title button {
    display: none;
  }
}
</style>